/** Batch Creation — the CSW desk's list (SeedTrac "Lot Number Batch Generation"). */
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { PlantRequired } from "@/components/app/plant-required";
import { useAuth } from "@/features/auth/store";
import { BatchListPage } from "@/features/warehouse/components/batch-list-page";
import { asStage, useDeskFacility } from "@/features/warehouse/route-helpers";
import { guardDesk } from "../../-guard";

const search = z.object({
  from: z.string().optional(),
  to: z.string().optional(),
  q: z.string().optional(),
  page: z.number().int().min(1).default(1),
});

export const Route = createFileRoute("/_app/warehouse/$stage/batch/")({
  validateSearch: search,
  beforeLoad: ({ params }) => guardDesk(params.stage, undefined, "batch"),
  component: Page,
});

function Page() {
  const { stage } = Route.useParams();
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const canCreate = useAuth((a) => a.can("warehouse.batch"));
  const facilityId = useDeskFacility();
  if (facilityId === undefined)
    return <PlantRequired title="Batch Creation" what="The batch list" />;
  return (
    <BatchListPage
      stage={asStage(stage)}
      facilityId={facilityId}
      search={s}
      canCreate={canCreate}
      onSearch={(next) =>
        // Any change but the page's own starts again at page 1.
        void navigate({ search: (prev) => ({ ...prev, page: 1, ...next }) })
      }
    />
  );
}
